import React from "react";
import utils from "../../utils/utils";
import "./style.less";

class PipelineSideBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sideMenu: []
    };
    this.isIphoneX = utils.isIphoneX();
    this.isIphone14ProMax = utils.isIphone14ProMax();
  }

  handleSideBarClick = (item, index) => {
    if (item.href) {
      const options = {
        sort: index
      }
      utils.jumpToUrl(this.props.routeParams, item.href, item.href, options, -1, this.props, false, {
        ptiId: `${this.props.templatePti}:sideBar:${index + 1}`,
        bizExtra: {
          model_block: 'sideBar',
          block_name: item.name,
        }
      }); 
    }
  }

  render() {
    const { baseConfig = {}, imgsList = [] } = this.props.config;
    return (
      <div className={(this.isIphoneX || this.isIphone14ProMax) ? 'pipeline-sideBar iphoneX' : 'pipeline-sideBar'} {...this.props['customAttributes']}>
        {
          baseConfig.titleImage && <img src={baseConfig.titleImage} alt="" className="side-title" />
        }
        {
          imgsList.length > 0 && imgsList.map((item, index) => {
            return <img src={item.image} alt="" className="side-entry" key={`side-${index}`} onClick={() => this.handleSideBarClick(item, index)} />
          })
        }
      </div>
    )
  }
}

export { PipelineSideBar };
export default PipelineSideBar;



// WEBPACK FOOTER //
// ./components/pipeline-sideBar/index.js